// @flow
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import NotFoundPage from 'pages/NotFoundPage';
import LoadingPage from 'pages/LoadingPage';
import ContentPageContainer from 'containers/ContentPageContainer';
import { fetchPage as fetchPageRaw } from '../redux/main/actions/pages';
import type { PageStates, Page } from '../redux/main/reducers/pages';

const { useEffect } = React;

const ContentPageContainerContainer = ({
  content,
  pageState,
  fetchPage,
  slug,
  amp
}: {
  content: Page,
  pageState: PageStates,
  fetchPage: Function,
  slug: string,
  amp: string
}) => {
  useEffect(
    () => {
      if (!amp) {
        fetchPage(slug);
      }
    },
    [fetchPage, slug, amp]
  );

  if (['FETCHING', 'UNFETCHED'].includes(pageState)) {
    if (amp) {
      // It's an AMP URL, but content is not already available.
      // Meaning it's disabled for that page.
      return <NotFoundPage />;
    }
    return <LoadingPage />;
  }

  if (content.id) {
    return <ContentPageContainer content={content} />;
  }

  return <NotFoundPage />;
};

const mapStateToProps = ({ pages }, { slug }: { slug: string }) => {
  const content = pages.byUrl[slug] || {};
  return {
    content,
    pageState: content.state || 'UNFETCHED',
    slug
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      fetchPage: fetchPageRaw
    }
  )(ContentPageContainerContainer)
);
